import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { SettingsNav } from "../settings/settings-nav.tsx";
import { useIsExpanded } from "../shell/device-class.ts";

import type { ReactElement } from "react";

const SettingsLayout = (): ReactElement => {
  const viewer = useViewer();
  const isExpanded = useIsExpanded();
  if (viewer === null || !isExpanded) {
    return <Outlet />;
  }
  return (
    <div className="flex gap-10 px-10 py-8">
      <div className="sticky top-8 max-h-[calc(100dvh-4rem)] w-60 shrink-0 self-start overflow-y-auto">
        <SettingsNav viewer={viewer} />
      </div>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});
